import config from 'config';

export const urls = {
  root: '/ecom',
  valentines: '/ecom/shop/browse/groceries/valentines',
  groceriesChristmas: '/ecom/shop/browse/groceries/christmas',
  offers: '/ecom/shop/browse/offers',
  entertainingHome: '/ecom/shop/browse/entertaining',
  browse: '/ecom/shop/browse',
  new: '/ecom/shop/browse/groceries/new',
  groceriesHome: '/ecom/shop/browse/groceries',
  serviceSelection: '/ecom/serviceselection',
  favourites: '/ecom/favourites',
  myOrdersPage: '/ecom/myaccount/my-orders',
  myDetailsPage: '/ecom/my-details',
  lists: '/ecom/lists',
  myWaitrosePage: '/ecom/my-waitrose',
  login: '/ecom/login',
  loginOAuth2: `${config.services.tokenClient.path}/v1/auth`,
  homepage: '/',
  registration: '/ecom/registration',
  customerServiceHomePage: '/ecom/help-information/customer-service',
  inspiration: '/home/inspiration.html',
  orderConfirmation: 'order-confirmation',
  trolleyPage: '/ecom/shop/trolley',
};

export const prodHost = 'www.waitrose.com';

export const specialistShopLinks = [
  {
    name: 'Cellar',
    tracking: 'topnav_control_cellar',
    url: 'http://www.waitrosecellar.com/',
  },
  {
    name: 'Florist',
    tracking: 'topnav_control_florist',
    url: 'http://www.waitroseflorist.com/',
  },
  {
    name: 'Garden',
    tracking: 'topnav_control_garden',
    url: 'http://www.waitrosegarden.com/',
  },
];
